import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {RockBottom} from "../RockBottom";
import {RockBottomSound} from "../sound/RockBottomSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {RockBottomXBetButton} from "../view/RockBottomXBetView";
import {RockBottomGameConfig} from "../RockBottomGameConfig";

export class RockBottomNormalBetPresentation implements FlowStatePresentation {

    private _normalStartDelay: number = 0.06;
    private _fastStartDelay: number = 0.01;

    constructor() {
        RockBottom.apiPlugin.events.on(APIEvent.BET, (data: APIFeatureBetEventData) => RockBottomNormalBetPresentation.onBet(data));
    }

    private static onBet(data: APIFeatureBetEventData): void {
        RockBottomGameConfig.IS_LUCKY_DRAW = (data.featureName === "LUCKY_DRAW");
    }

    public start(flowStateController: FlowStateController): void {
        RockBottom.foreground.stopPaperFlyAnimation();
        RockBottom.initialCountUp.remove();
        RockBottom.bigWinCountUp.remove();
        RockBottom.background.onSpinStart();
        RockBottom.xSplitView.resetVariable();
        RockBottom.xBetView.enableXBetBtn(false, 0);
        RockBottom.characterIntro.stopCharacterIntro(true);

        if (RockBottom.isBoostedBetAllowed()) {
            const xBetBtn: RockBottomXBetButton = RockBottom.xBetView.getXBetButton();
            xBetBtn.stopXBetIdleAnim();
        }

        RockBottom.midSymExpand.removeExpandAnims();
        RockBottom.freeSpinView.updateSpinsCounter(0, true);
        RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.REELS_SPINNING});

        const promises: Promise<any>[] = [];
        RockBottom.reels.forEach((reel, reelId) => {
            const isStickyReel: boolean = RockBottom.inBonusGame && (reelId === 0 || reelId === 4);
            promises.push(reel.startSpin(!isStickyReel, (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay) * reelId));
        });

        Promise.all(promises).then(res => flowStateController.finish());
    }
}